@for (menu of menuItems; track menu) {
  <a [id]="menu.id"
    class='parent'
    slot="primary-items"
    [routerLink]="menu.url"
    [attr.active]="isActive(menu) ? 'active' : null"
    (click)="onMenuClicked(null, menu, $event)">
    {{menu.title}}
  </a>
  @if (menu.subItems && menu.subItems.length) {
    <c-navigation *ngIf="menu.subItems && menu.subItems.length" slot="sub" [caption]="menu.title" 
      [attr.active]="isActive(menu) ? 'active' : null" [target]="menu.url">
      <a *ngFor="let subMenu of menu.subItems"
          slot="primary-items"
          [routerLink]="subMenu.url"
          [id]="subMenu.id" 
          (click)="onMenuClicked(menu, subMenu, $event)" [attr.class]="isActive(subMenu) ? 'active' : ''">{{subMenu.title}}</a>
  </c-navigation>
  }
}

<div slot="secondary-items">
  <cal-product-search></cal-product-search>
</div>
 <div slot="secondary-items" ngbDropdown container="body" placement="bottom-right" class="user-menu">
     <a id="userMenu" ngbDropdownToggle>
         <i class="far fa-user-circle"></i> {{profile?.name}}
     </a>
     <div ngbDropdownMenu aria-labelledby="userMenu" class="user-menu-dropdown">
         <div class="user-info-row">
             <span class="user-info-label">{{resources.Username}}</span>
             <span class="user-info-value">{{ profile?.idTokenClaims?.userid }}</span>
         </div>
         <div class="user-info-row">
             <span class="user-info-label">{{resources.Name}}</span>
             <span class="user-info-value">{{ profile?.idTokenClaims?.given_name }} {{ profile?.idTokenClaims?.family_name }}</span>
         </div>
         <div class="user-info-row">
             <span class="user-info-label">{{resources.Email}}</span>
             <span class="user-info-value">{{ profile?.idTokenClaims?.email }}</span>
         </div>
         <div class="dropdown-divider"></div>
         <button type="button" ngbDropdownItem class="user-menu-logout" (click)="logout()">{{resources.Logout}}</button>
     </div>
</div>